import Checkbox from 'antd/lib/checkbox'
import Spin from 'antd/lib/spin'
import { CIMSCheckboxProps } from './types'
import { useDisabledOptions, DisabledOptions } from 'hooks/useDisabledOptions'
import CIMSTooltip from '../CIMSTooltip'

const CIMSCheckbox: React.FC<CIMSCheckboxProps> = ({
  loading,
  disabled,
  tooltipPlacement,
  ...props
}) => {
  const loadingOptions: DisabledOptions = {
    disabled: loading ?? false,
    reason: 'loading',
  }
  const withLoadingOptions: (DisabledOptions | undefined)[] = Array.isArray(
    disabled
  )
    ? [...disabled, loadingOptions]
    : [disabled, loadingOptions]

  const [options, { some }] = useDisabledOptions(
    disabled ? withLoadingOptions : loadingOptions
  )

  return loading === true ? (
    <Spin size="small" />
  ) : (
    <CIMSTooltip disabled={options} placement={tooltipPlacement}>
      <Checkbox
        disabled={some}
        // Stops click event from bubbling to parent elements
        onClick={(e) => e.stopPropagation()}
        {...props}
      />
    </CIMSTooltip>
  )
}

export default CIMSCheckbox
